export default __webpack_public_path__ + "static/media/g-7.76ea5765.jpg";